import * as React         from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

import A1Logo              from '../../assets/images/socialMobileLogos/a1_logo.png';
import mtsLogo             from '../../assets/images/socialMobileLogos/MTS_Logo.svg';
import telegramLogo        from '../../assets/images/socialMobileLogos/telegram_logo.svg';
import viberLogo           from '../../assets/images/socialMobileLogos/viber_logo.svg';
import whatsAppLogo        from '../../assets/images/socialMobileLogos/whatsApp_logo.svg';
import { useSiteSettings } from '../../providers/siteSettings';

const CallMeContactsList = function() {
  const { t } = useTranslation();

  const siteSettings = useSiteSettings();

  const validateNumber = React.useCallback((number) => {
    return number.replace(/[^\d+]/g, '');
  }, []);

  return (
    <div className={'list'}>
      <div>
        {siteSettings.data.CONTACTS.PHONE.map((phone) => {
          switch (phone.signature) {
            case 'МТС':
              return (
                <div
                  className={'phoneContainer'}
                  key={phone.value}
                >
                  <a href={`tel:${phone.value}`}>{phone.value}</a>
                  <img
                    alt={`${t('client_logo')} mts`}
                    src={mtsLogo}
                    title={`${t('client_logo')} mts`}
                  />
                </div>
              );

            case 'A1':
              return (
                <div
                  className={'phoneContainer'}
                  key={phone.value}
                >
                  <a href={`tel:${phone.value}`}>{phone.value}</a>
                  <img
                    alt={`${t('client_logo')} A1`}
                    src={A1Logo}
                    title={`${t('client_logo')} A1`}
                  />
                </div>
              );

            default:
              return (
                <div
                  className={'phoneContainer'}
                  key={phone.value}
                >
                  <a href={`tel:${phone.value}`}>{phone.value}</a>
                </div>
              );
          }
        })}
      </div>
      <div className={'messengerContainer'}>
        {siteSettings.data.CONTACTS.VIBER && (
          <div className={'messengerItem'}>
            <a
              href={`viber://chat?number=${validateNumber(siteSettings.data.CONTACTS.VIBER[0].value)}`}
              rel={'nofollow'}
              target={'_blank'}
            >
              <img
                alt={`${t('client_logo')} viber`}
                src={viberLogo}
                title={`${t('client_logo')} viber`}
              />
            </a>
          </div>
        )}
        {siteSettings.data.CONTACTS.TELEGRAM && (
          <div className={'messengerItem'}>
            <a
              href={`https://t.me/${siteSettings.data.CONTACTS.TELEGRAM[0].value}`}
              rel={'nofollow'}
              target={'_blank'}
            >
              <img
                alt={`${t('client_logo')} telegram`}
                src={telegramLogo}
                title={`${t('client_logo')} telegram`}
              />
            </a>
          </div>
        )}
        {siteSettings.data.CONTACTS.WHATSAPP && (
          <div className={'messengerItem'}>
            <a
              href={`https://wa.me/${validateNumber(siteSettings.data.CONTACTS.WHATSAPP[0].value)}`}
              rel={'nofollow'}
              target={'_blank'}
            >
              <img
                alt={`${t('client_logo')} WhatsApp`}
                src={whatsAppLogo}
                title={`${t('client_logo')} WHATSAPP`}
              />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default CallMeContactsList;
